import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Applicationdefs } from '../../../../../../../core/entities/applicationdefs.model';
import { Typefinders } from '../../../../../../../core/entities/typefinders.model';
import { ApplicationdefsService } from '../../../../../../../core/repositories/applicationdefs.service';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';

@Injectable()
export class EditDialogsApplicationdefsService {

  applicationdefs: Applicationdefs = new Applicationdefs();
  originalApplicationdefs: Applicationdefs = new Applicationdefs();

  allApplicationdefs: Applicationdefs[] = [];
  changetitulo: boolean = false;
  disabledForm: boolean = false;

  typeSelection: any[] = [{name: String, value:Boolean}];
  typeSelectionOriginal: any[] = [{name: String, value:Boolean}];

  typefinders: Typefinders[] = new Array<Typefinders>();

  constructor(private applicationdefsService: ApplicationdefsService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.applicationdefs = data.applicationdef;
    this.changetitulo = data.titulochange;
    this.disabledForm = data.disabledApplicationdef;
    this.originalApplicationdefs = _.cloneDeep(this.applicationdefs);
    console.log(data);

    return forkJoin({
        valor0: this.applicationdefsService.findAll(),
        valor1: this.internalHomeService.allTypefinders()
    }).pipe(map(dataGroup => {

      this.allApplicationdefs = dataGroup.valor0 as Applicationdefs[];;
      this.typefinders = dataGroup.valor1;

      if(this.applicationdefs.typefinders.length > 0){
        for(let i = 0; i < this.typefinders.length; i++){

          this.typeSelection.push({name: this.typefinders[i].code, value: false});

          for(let j = 0; j < this.applicationdefs.typefinders.length; j++){
            if(this.applicationdefs.typefinders[j].code === this.typeSelection[i].name){
              this.typeSelection[i].value = true;
            }
          }
        }
      }else{
        for(let i = 0; i < this.typefinders.length; i++){
          this.typeSelection.push({name: this.typefinders[i].code, value: false});
        }
      }

      console.log(this.typeSelection);

      if (Utils.noUndfAndNull(data.applicationdef)) {
        this.applicationdefs = _.cloneDeep(data.applicationdef);
      }

      this.typeSelectionOriginal = _.cloneDeep(this.typeSelection);
      return true;
    }));
  }

  /**
  * @description
  * Guarda el applicationdef
  */
  public guardar(): Observable<any> {
    console.log('guardar');

    if (Utils.noUndfAndNull(this.applicationdefs.id, "")) {

      this.gestionCheckBox();
      /*comparamos el applicationdef original con el modificado*/
      let compareApplicationdef = this.compare(this.applicationdefs, this.originalApplicationdefs);

      if(compareApplicationdef){
        return of(-1);
      }else{
        return this.applicationdefsService.postApplicationdef(this.applicationdefs);
      }

    } else {
      this.gestionCheckBox();
      return this.applicationdefsService.postApplicationdef(this.applicationdefs);
    }
  }

  /**
  * @description
  * Adecuamos los chekbox seleccionados con los typefinders que corresponden
  */
  private gestionCheckBox(){
    for(let i = 0; i < this.typeSelection.length; i++){
      for(let j = 0; j < this.typefinders.length; j++){
        if(!this.typeSelection[i].value && this.typefinders[j] != null){
          if(this.typeSelection[i].name === this.typefinders[j].code){
            this.typefinders.splice(j, 1);
            j--;
          }
        }
      }
    }
    this.applicationdefs.typefinders = this.typefinders;
  }

  /**
  * @description
  * Comprueba si dos Applicationdefs son iguales.
  * @param datoX Applicationdef 1
  * @param datoY Applicationdef 2
  * @returns True si son iguales
  */
  public compare(itemX:Applicationdefs, itemY:Applicationdefs):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

       if (itemX.code !== "" || !Utils.noUndfAndNull(itemX.code))
       return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
     return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.applicationdefs = new Applicationdefs();
    this.typeSelection = [];
  }

}
